import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import {
    Products_list_api,
    wishlist_api,
    wishlist_remove_api,
    get_wishlist,
    subcategory_details,
    category_details,
    new_arrivals,
    new_sale
} from "../service/api.js";
import Head_CateHead from "../components/Head_CateHead.js";
import { Slide_title } from "../components/slide-title.js";
import { Spe_offer } from "../components/spe_offer.js";
import { Footer } from "../components/Footer.js";
import filledHeartImage from "./../assets/img/heart.svg";
import unfilledHeartImage from "./../assets/img/heartunfilled.svg";
import { ProductGridSkeleton } from "../components/Skeleton.js";
import { ProductGridImage, productImageUrl } from "../components/ProductGridImage.js";
import { readHeaderMenu } from "../service/headerCache.js";
import { Pagination } from "@mui/material";
import Breadcrumb from '../components/Breadcrumb.js';  // Ensure correct import path

export const Products = () => {
    const { categoryslug, subcategoryslug } = useParams();
    const subCategoryIdRef = useRef(0);
    const requestRef = useRef(0);

    const [crumbs, setcrumbs] = useState([]);
    const [productArray, setProductArray] = useState([]);
    const [selectedSortingOptions, setSelectedSortingOptions] = useState("default");
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("token"));
    const [wishlistProductId, setWishlistProductId] = useState([]);

    const [title, setTitle] = useState("");
    const [CategoryName, setCategoryName] = useState("");
    const [PortalSlug, setPortalSlug] = useState("");
    const [description, setdescription] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [listLoading, setListLoading] = useState(true);
    const [bannerimage, setbannerimage] = useState("")
    const [totalPages, settotalPages] = useState(0);

    useEffect(() => {
        var vrcrumbs = [{ label: "Home", path: "/" }];
        if (PortalSlug != '') {
            vrcrumbs.push({ label: CategoryName, path: '/' + PortalSlug });
        } else {
            vrcrumbs.push({ label: CategoryName, path: '/category/' + categoryslug });
        }
        vrcrumbs.push({ label: title, path: "" });

        setcrumbs(vrcrumbs);
    }, [CategoryName, categoryslug, title, PortalSlug]);

    useEffect(() => {
        const requestId = ++requestRef.current;
        setProductArray([]);
        setPageNumber(1);
        setListLoading(true);
        loadPage(1, requestId);
    }, [categoryslug, subcategoryslug]);

    const cachedSubcategory = () => {
        const menu = readHeaderMenu() || [];
        const category = menu.find((item) => item.Slug === categoryslug);
        const sub = category?.SubCategory?.find((item) => item.Slug === subcategoryslug);
        return { category, sub };
    };

    const showProducts = (rows, pages, requestId) => {
        if (requestRef.current !== requestId) return;
        setProductArray(Array.isArray(rows) ? rows : []);
        if (pages != null) settotalPages(pages);
        setListLoading(false);
    };

    // Product cards render from this response alone. Wishlist only fills the heart icons later.
    const loadProducts = async (subCategoryId, pageNo, requestId) => {
        try {
            subCategoryIdRef.current = subCategoryId;
            const response = await Products_list_api({
                SubCategoryID: subCategoryId,
                Sort: selectedSortingOptions,
                RecordsPerPage: 24,
                PageNo: pageNo,
            });
            if (response?.status === 200) {
                showProducts(response.data.Data, response.data.totalPages, requestId);
            } else if (requestRef.current === requestId) {
                setListLoading(false);
            }
        } catch (error) {
            console.error(error);
            if (requestRef.current === requestId) setListLoading(false);
        }
    };

    const loadPage = async (pageNo, requestId) => {
        const { category, sub } = cachedSubcategory();
        if (category?.CategoryName) setCategoryName(category.CategoryName);
        if (sub?.SubCategoryName) {
            setTitle(sub.SubCategoryName);
            setdescription(sub.Description || "");
            setbannerimage(sub.SubCategoryBanner || "");
        }

        getUserWishlist();

        try {
            if (subcategoryslug === "new" || subcategoryslug === "sale") {
                setTitle(subcategoryslug === "new" ? "New" : "Sale");
                const response = subcategoryslug === "new"
                    ? await new_arrivals(pageNo)
                    : await new_sale(pageNo);
                if (response?.status === 200) {
                    showProducts(response.data.data, response.data.totalPages, requestId);
                } else if (requestRef.current === requestId) {
                    setListLoading(false);
                }
                return;
            }

            // The saved menu already has the subcategory id, so the product list
            // does not wait for getcategory or getsubcategory.
            if (sub?.SubCategoryID) {
                loadProducts(sub.SubCategoryID, pageNo, requestId);
            }

            let categoryId = category?.CategoryID;
            if (!categoryId) {
                const categoryRes = await category_details(categoryslug);
                if (requestRef.current !== requestId) return;
                categoryId = categoryRes?.data?.Data?.[0]?.CategoryID;
                if (categoryRes?.data?.Data?.[0]?.CategoryName) {
                    setCategoryName(categoryRes.data.Data[0].CategoryName);
                }
            }

            const subRes = await subcategory_details(categoryId, subcategoryslug);
            if (requestRef.current !== requestId) return;
            const freshSub = subRes?.data?.Data?.[0];
            if (subRes?.data?.portalInfo && subRes.data.PortalCategoryMapList?.length > 0) {
                setPortalSlug(subRes.data.portalInfo.Slug);
            }
            if (freshSub?.SubCategoryName) {
                setTitle(freshSub.SubCategoryName);
                setdescription(freshSub.Description);
                setbannerimage(freshSub.SubCategoryBanner);
                if (!sub?.SubCategoryID) {
                    await loadProducts(freshSub.SubCategoryID, pageNo, requestId);
                }
            } else if (!sub?.SubCategoryID && requestRef.current === requestId) {
                setListLoading(false);
            }
        } catch (error) {
            console.error(error);
            if (!sub?.SubCategoryID && requestRef.current === requestId) setListLoading(false);
        }
    };

    const getUserWishlist = async () => {
        try {
            const res = await get_wishlist();
            const wishListId = res.data?.Data?.map((item) => item.ProductID);
            setWishlistProductId([...wishListId]);
        } catch (error) {
            console.error(error);
        }
    };

    const toggleWishlist = async (ProductID, UserProductWishlist) => {
        try {
            let response;
            const checkWish = wishlistProductId.find((userWish) => userWish === ProductID);

            if (!checkWish) {
                response = await wishlist_api(ProductID);

                if (response.status === 200) {
                    const updatedProductArray = productArray.map((product) =>
                        product.ProductID === ProductID
                            ? {
                                ...product,
                                UserProductWishlist: [response.data.UserProductWishlist],
                            }
                            : product
                    );

                    setProductArray(updatedProductArray);
                }
            } else {
                response = await wishlist_remove_api(ProductID);

                if (response.status === 200) {
                    const updatedProductArray = productArray.map((product) =>
                        product.ProductID === ProductID
                            ? {
                                ...product,
                                UserProductWishlist: [],
                            }
                            : product
                    );

                    setProductArray(updatedProductArray);
                }
            }
            getUserWishlist()
        } catch (error) {
            console.error("Error toggling wishlist:", error);
        }
    };
    const handlePageChange = async (event, page) => {
        const requestId = ++requestRef.current;
        setListLoading(true);
        setPageNumber(page);
        window.scrollTo(0, 0);
        try {
            if (subcategoryslug === "new" || subcategoryslug === "sale") {
                const response = subcategoryslug === "new"
                    ? await new_arrivals(page)
                    : await new_sale(page);
                if (response?.status === 200) {
                    showProducts(response.data.data, response.data.totalPages, requestId);
                } else if (requestRef.current === requestId) {
                    setListLoading(false);
                }
                return;
            }
            if (subCategoryIdRef.current) {
                await loadProducts(subCategoryIdRef.current, page, requestId);
            } else if (requestRef.current === requestId) {
                setListLoading(false);
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
            if (requestRef.current === requestId) setListLoading(false);
        }
    }
    {/* <div style={{ position: 'relative', height: '250px', background: '#F2F9FB', marginBottom: '40px' }}>
                        <h1 style={{ textAlign: 'center', paddingTop: '80px', color: '#01AEF0', fontSize: '3.5vw' }}> <span dangerouslySetInnerHTML={{ __html: title }} /></h1>
                        <span style={{ color: '#DFF3FA', position: 'absolute', left: '83%', top: '-30%', fontSize: '10.5vw', fontFamily: 'poppins', fontWeight: '600' , height:"300px" , overflow:"hidden" }}><span dangerouslySetInnerHTML={{ __html: title }} /></span>
                        <span style={{ color: '#DFF3FA', position: 'absolute', right: '83%', bottom: '-14%', fontSize: '10.5vw', fontFamily: 'poppins', fontWeight: '600' , height:"260px" , overflow:"hidden"  }}><span dangerouslySetInnerHTML={{ __html: title }} /></span>
                    </div> */}

    return (
        <div>
            <Head_CateHead />
            <div className="collection_wrapper">
                {bannerimage == null || bannerimage == '' ?

                    <div style={{ position: 'relative', height: '250px', background: '#F2F9FB', marginBottom: '40px' }}>
                        <h1 style={{ textAlign: 'center', paddingTop: '80px', color: '#01AEF0', fontSize: '3.5vw' }} dangerouslySetInnerHTML={{ __html: title }} />
                        <span style={{ color: '#DFF3FA', position: 'absolute', width: "300px", left: '80%', top: '-30%', fontSize: '10.5vw', fontFamily: 'poppins', fontWeight: '600', height: "300px", overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: title }} />
                        <span style={{ color: '#DFF3FA', position: 'absolute', right: '83%', bottom: '-14%', fontSize: '10.5vw', fontFamily: 'poppins', fontWeight: '600', height: "260px", overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: title }} />
                    </div>
                    :
                    <img style={{ width: '100%', marginBottom: '40px' }} src={process.env.REACT_APP_API_URL + bannerimage} alt={String(title || "Category").replace(/<[^>]*>/g, "")} />
                }
                <div className="container">
                    <Breadcrumb crumbs={crumbs} />
                    {listLoading ? (
                        <ProductGridSkeleton />
                    ) : (
                        <div className="products_list">
                            {productArray.map((product, index) => (
                                <Link to={`/product/${product.Slug}`} key={index}>
                                    <div className="arrivals_box" key={index}>
                                        <div className="arrivals_img">
                                            <div className="product_head">
                                                {isAuthenticated && (
                                                    <button
                                                        className="product_save"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            toggleWishlist(product.ProductID, product.UserProductWishlist);
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                wishlistProductId.find((wishPro) => wishPro === product.ProductID)
                                                                    ? filledHeartImage
                                                                    : unfilledHeartImage
                                                            }
                                                            alt="Heart Icon"
                                                        />
                                                    </button>
                                                )}
                                            </div>
                                            <ProductGridImage
                                                src={productImageUrl(product.ProductImage)}
                                                alt={product.ProductName || "Product"}
                                            />
                                        </div>
                                        <div className="arrivals_content">
                                            <div className="arrivals_content_title">
                                                <h3>{product.ProductName}</h3>
                                                <p className="sku" style={{ marginLeft: "1", fontSize: "0.83vw", color: "#252525" }}>
                                                    SKU: {product.SKU}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                    {totalPages > 1 && (
                        <div className="trend_pagination" style={{ display: 'block', position: 'relative', paddingBottom: '100px', paddingTop: '50px' }}>
                            <Pagination count={totalPages} shape="rounded" onChange={handlePageChange} />
                        </div>
                    )}
                </div>
            </div>
            {/* <Spe_offer /> */}
            <Footer />
        </div>
    );
};

